// src/app/api.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpContext, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment'; // <-- Add this import
import {formatDate} from '@angular/common';
import {SKIP_GLOBAL_LOADER} from '../core/http-context';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class ApiService {

  private baseUrl = environment.baseUrl; // <-- Use environment variable

  constructor(private http: HttpClient) { }

  private toDateParam(value: any): string {
    if (!value) {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? '' : formatDate(date, 'yyyy-MM-dd', 'en-IN');
  }
  logIn(data: object): Observable<any> {
      return this.http.post<{ access: string, refresh: string, user: object }>(
          `${this.baseUrl}login/`,
          data,
          {context: new HttpContext().set(SKIP_GLOBAL_LOADER, true)},
      );
  }

  // OTP Verification
  sendMobileVerificationOTP(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}send_phone_otp/`, data)
  }

  verifyMobileOTP(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}verify_phone_otp/`, data)
  }


  // refreshToken(token: string | null){
  //   this.http.post<any>('token/refresh/', token)
  // }

  getVehicleDatabase(pageNo: number, pageSize: number, searchText: string | null): Observable<any> {

    // return this.http.get(`${this.baseUrl}vehicles/`, { headers: {
    //   Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzI1MzQxNzQ3LCJpYXQiOjE3MjUzMzgxNDcsImp0aSI6IjRkZGE0MDI0ZTcwNDQwZDBhYmFmOWJkZWU2OWY2MmI1IiwidXNlcl9pZCI6Mn0.S9ITq6XAz0NYtO34Vq9ypo7U2gjv4Ej_Xw7kU2VyBL8"}});
    // }
    return this.http.get(`${this.baseUrl}vehicles/?page=${pageNo}&page_size=${pageSize}&search=${searchText}`);
  }

  getSearchVehicle(pageNo: number, pageSize: number, searchText: string | null): Observable<any> {
    return this.http.get(`${this.baseUrl}vehicles/?search=${searchText}&page=${pageNo}&page_size=${pageSize}`);
  }

  exportVehicleDB(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {
    if (searchText) {
      return this.http.get(`${this.baseUrl}vehicles/export_to_excel/?search=${searchText}&page=${pageNo}&page_size=${pageSize}`,
        {
          responseType: 'blob',
          observe: 'response'
        });
    } else {
      return this.http.get(`${this.baseUrl}vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
        {
          responseType: 'blob',
          observe: 'response'
        }
      );
    }
  }

  getVehicleDBSearchSuggestions(searchText: string): Observable<any> {
    return this.http.get(`${this.baseUrl}vehicles/search_suggestion?q=${encodeURIComponent(searchText || '')}`);
  }

  addVehicle(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}vehicles/`, data);
  }

  deleteVehicle(id: number) {
    return this.http.delete(`${this.baseUrl}vehicles/${id}/`)
  }

  trackVehicle(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}track-vehicle/?page=${page}&page_size=${pageSize}`, data)
  }

  exportTrackVehicle(data: Object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}track-vehicle/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }
  getTrackVehicleNumberSuggestions(searchText: string) {
    return this.http.get(`${this.baseUrl}track-vehicle/vehicle_suggestion?q=${searchText}`);
  }

  getTrackVehicleSearchSuggestion(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}track-vehicle/search_suggestion`, data);
  }

  generateReport(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}generate-report/?page=${page}&page_size=${pageSize}`, data

    )
  }
  exportReport(data: object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}generate-report/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }
  getProfiledetail(pkId: number) {
    return this.http.get(`${this.baseUrl}users/${pkId}/`)
  }
  // updateProfile(pkId:number, data: object):  Observable<any>{
  //   return this.http.put(`${this.baseUrl}users/${pkId}/`, data)
  // }
  updateProfile(pkId: number, data: object): Observable<any> {
    return this.http.patch(`${this.baseUrl}users/${pkId}/`, data)
  }
  // exportVehicleDatabase():  Observable<any>{
  //   return this.http.get(`${this.baseUrl}export-vehicle/`)
  // }
  changePassword(data: object): Observable<any> {
    return this.http.patch(`${this.baseUrl}change-password/`, data)
  }
  downloadTemplate(): Observable<HttpResponse<Blob>> {
      return this.downloadImportTemplate('vehicle');
  }

    downloadImportTemplate(templateType: string): Observable<HttpResponse<Blob>> {
        const params = new HttpParams().set('type', templateType);
        return this.http.get(`${this.baseUrl}download-template/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
  }

  getLogs(options: {
    page?: number;
    pageSize?: number;
    dateRange?: string;
    date?: string;
    status?: string;
    levels?: string[];
    categories?: string[];
    search?: string;
  } = {}): Observable<any> {
    let params = new HttpParams()
      .set('page', String(options.page || 1))
      .set('page_size', String(options.pageSize || 50))
      .set('date_range', options.dateRange || 'today');

    if (options.date) {
      params = params.set('date', options.date);
    }
    if (options.status && options.status !== 'all') {
      params = params.set('status', options.status);
    }
    if (options.levels && options.levels.length > 0) {
      params = params.set('levels', options.levels.join(','));
    }
    if (options.categories && options.categories.length > 0) {
      params = params.set('categories', options.categories.join(','));
    }
    if (options.search) {
      params = params.set('search', options.search);
    }
    return this.http.get(`${this.baseUrl}logs/`, { params });
  }
  getLoginActivity(page: number, pageSize: number, orgId: number | string | null = null): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/login-activity/`, { params });
  }

  listSubscriptions(page: number, pageSize: number, searchText: string = '', status: string = '', billingType: string = '', orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText || '');
    if (status) {
      params = params.set('status', status);
    }
    if (billingType) {
      params = params.set('billing_type', billingType);
    }
    if (orgId) {
      params = params.set('organization', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}subscriptions/`, { params });
  }

  getSubscription(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/`);
  }

  createSubscription(data: object) {
    return this.http.post(`${this.baseUrl}subscriptions/`, data);
  }

  updateSubscription(id: number, data: object) {
    return this.http.put(`${this.baseUrl}subscriptions/${id}/`, data);
  }

  deleteSubscription(id: number) {
    return this.http.delete(`${this.baseUrl}subscriptions/${id}/`);
  }

  uploadSubscriptionQuotation(data: FormData) {
    return this.http.post(`${this.baseUrl}subscriptions/upload-quotation/`, data);
  }

  listSubscriptionDocuments(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/documents/`);
  }

  uploadSubscriptionDocument(id: number, data: FormData) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/documents/`, data);
  }

  listSubscriptionPayments(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/payments/`);
  }

  addSubscriptionPayment(id: number, data: object) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/payments/`, data);
  }

  updateSubscriptionPayment(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}subscriptions/${id}/payments/`, data);
  }

  sendSubscriptionExpiryAlert(id: number, data: object = {}) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/send-expiry-alert/`, data);
  }

  sendSubscriptionPaymentReminder(id: number, data: object = {}) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/send-payment-reminder/`, data);
  }

  listLeads(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.source) {
      params = params.set('source', filters.source);
    }
    if (filters.assigned_to) {
      params = params.set('assigned_to', filters.assigned_to);
    }
    if (filters.date_from) {
      params = params.set('date_from', this.toDateParam(filters.date_from));
    }
    if (filters.date_to) {
      params = params.set('date_to', this.toDateParam(filters.date_to));
    }
    if (filters.organization) {
      params = params.set('organization', filters.organization);
    }
    if (filters.followup) {
      params = params.set('followup', filters.followup);
    }
    return this.http.get(`${this.baseUrl}leads/`, { params });
  }

  getLeadDashboard() {
    return this.http.get(`${this.baseUrl}leads/dashboard/`);
  }

  getLead(id: number) {
    return this.http.get(`${this.baseUrl}leads/${id}/`);
  }

  convertLeadToSalesInstallationPartner(id: number) {
    return this.http.post(`${this.baseUrl}leads/${id}/convert-to-sales-installation-partner/`, {});
  }

    revertSalesInstallationPartnerToLead(partnerId: number) {
        return this.http.post(`${this.baseUrl}sales-installation-partners/${partnerId}/revert-to-lead/`, {});
    }

  createLead(data: object) {
    return this.http.post(`${this.baseUrl}leads/`, data);
  }

  updateLead(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${id}/`, data);
  }

  deleteLead(id: number) {
    return this.http.delete(`${this.baseUrl}leads/${id}/`);
  }

  getLeadActivities(id: number) {
    return this.http.get(`${this.baseUrl}leads/${id}/activities/`);
  }

  addLeadFollowUp(id: number, data: object) {
    return this.http.post(`${this.baseUrl}leads/${id}/follow-ups/`, data);
  }

  updateLeadFollowUp(leadId: number, followUpId: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${leadId}/follow-ups/${followUpId}/`, data);
  }

  deleteLeadFollowUp(leadId: number, followUpId: number) {
    return this.http.delete(`${this.baseUrl}leads/${leadId}/follow-ups/${followUpId}/`);
  }

  listLeadFollowUps(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.assigned_to) {
      params = params.set('assigned_to', filters.assigned_to);
    }
    if (filters.date) {
      params = params.set('date', this.toDateParam(filters.date));
    }
    return this.http.get(`${this.baseUrl}leads/follow-ups/`, { params });
  }

  addLeadDemo(id: number, data: object) {
    return this.http.post(`${this.baseUrl}leads/${id}/demos/`, data);
  }

  updateLeadDemo(leadId: number, demoId: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${leadId}/demos/${demoId}/`, data);
  }

  deleteLeadDemo(leadId: number, demoId: number) {
    return this.http.delete(`${this.baseUrl}leads/${leadId}/demos/${demoId}/`);
  }

  listLeadDemos(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.date) {
      params = params.set('date', this.toDateParam(filters.date));
    }
    return this.http.get(`${this.baseUrl}leads/demos/`, { params });
  }
  uploadGuidelines() {
    return this.http.get(`${this.baseUrl}upload-guidelines/`)
  }
  bulkUpload(data: Object) {
    return this.http.post(`${this.baseUrl}bulk-upload/`, data)
  }

    bulkUploadHotlist(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-hotlist/`, data);
    }

    bulkUploadBlocklist(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-blocklist/`, data);
    }

    validateInitialOccupancyUpload(organizationId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('organization_id', String(organizationId));
        formData.append('validate_only', 'true');
        return this.http.post(`${this.baseUrl}bulk-upload-initial-occupancy/`, formData);
    }

    bulkUploadInitialOccupancy(organizationId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('organization_id', String(organizationId));
        return this.http.post(`${this.baseUrl}bulk-upload-initial-occupancy/`, formData);
    }
  getVehicle(pk: number) {
    return this.http.get(`${this.baseUrl}vehicles/${pk}/`)

  }
  // updateVehicle(pk: number, data: Object){
  //   return this.http.put(`${this.baseUrl}vehicles/${pk}/`, data)
  // }
  updateVehicle(pk: number, data: Partial<any>): Observable<any> {
    return this.http.patch(`${this.baseUrl}vehicles/${pk}/`, data)
  }
  forgotPassword(data: Object) {
    return this.http.post(`${this.baseUrl}password-reset/`, data)
  }
  forgotPasswordConfirm(data: Object) {
    return this.http.post(`${this.baseUrl}password-reset-confirm/`, data)
  }
  contactUsPrivate(data: Object) {
    return this.http.post(`${this.baseUrl}contact/`, data)
  }

    listContactUsRequests(page: number, pageSize: number) {
        const params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        return this.http.get(`${this.baseUrl}contact-us/`, {params});
    }
  // Black Listed Vehicle API's
  addBlackListedVehicle(data: Object) {
    return this.http.post(`${this.baseUrl}blacklisted-vehicles/`, data)
  }
  getBlackedVehicle(page: number, pageSize: number, searchText: string | null) {
    return this.http.get(`${this.baseUrl}blacklisted-vehicles/?page=${page}&page_size=${pageSize}&search=${searchText}`)
  }
  unblack(id: number) {
    return this.http.delete(`${this.baseUrl}blacklisted-vehicles/${id}/`)
  }
  exportBlacklisted(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}blacklisted-vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }


  // Users API
  signUp(data: Object) {
    return this.http.post(`${this.baseUrl}users/`, data)
  }
  getGroups() {
    return this.http.get(`${this.baseUrl}groups/`)
  }
  organization() {
    return this.http.get(`${this.baseUrl}organizations/`)
  }
  getOrganizations(pageSize: number = 1000) {
      return this.http.get(`${this.baseUrl}organizations/?filter_customers=true&page=1&page_size=${pageSize}`)
  }
  getUserdetail(page: number, pageSize: number, searchText: string | null, orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('is_staff_page', 'true')
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText ?? '');
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/`, { params });
  }

  getAssignableUsers(page: number, pageSize: number, searchText: string | null, orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('is_staff_page', 'true')
      .set('assignable_only', 'true')
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText ?? '');
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/`, { params });
  }
  deleteUser(id: number) {
    return this.http.delete(`${this.baseUrl}users/${id}/`)
  }

    toggleStaffActive(userId: number, isActive: boolean) {
        return this.http.patch(`${this.baseUrl}users/${userId}/toggle-active/`, {is_active: isActive});
    }
  exportStaff(pageNo: number, pageSize: number, searchText: string | null, orgId: number | string | null = null): Observable<HttpResponse<Blob>> {
    let params = new HttpParams()
      .set('page', pageNo)
      .set('page_size', pageSize);
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/export_to_excel/`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }


  // Organization
  getOrganization(id: number) {
    return this.http.get(`${this.baseUrl}organizations/${id}/`)
  }

    getOrganizationOnboardingChecklist(id: number) {
        return this.http.get<any>(`${this.baseUrl}organizations/${id}/onboarding-checklist/`)
    }
  // editOrganization(id: number, data: Object){
  //   return this.http.put(`${this.baseUrl}organizations/${id}/`, data)
  // }
  editOrganization(id: number, data: Partial<any>): Observable<any> {
    return this.http.patch(`${this.baseUrl}organizations/${id}/`, data)
  }
  getCityState(id: number) {
    return this.http.get(`${this.baseUrl}locations/pincode/${id}/`)
  }

    getAllOrganization(page: number, pageSize: number, searchText: string | null, ordering: string | null = null) {
        let url = `${this.baseUrl}organizations/?filter_customers=true&page=${page}&page_size=${pageSize}&search=${searchText ?? ''}`;
        if (ordering) {
            url += `&ordering=${ordering}`;
        }
        return this.http.get(url);
  }
  addOrganization(data: Object) {
    return this.http.post(`${this.baseUrl}organizations/`, data)
  }
  deleteOrganization(id: number) {
    return this.http.delete(`${this.baseUrl}organizations/${id}/`)
  }

  exportOraganization(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}organizations/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  setAlertDirections(data: object){
    return this.http.patch(`${this.baseUrl}organizations/alert-direction-config`, data)
  }
  getAlertDirections(){
    return this.http.get(`${this.baseUrl}organizations/alert-direction-config`)
  }

    getNotificationPreferences() {
        return this.http.get(`${this.baseUrl}notification-preferences/`);
    }

    updateNotificationPreferences(data: object) {
        return this.http.put(`${this.baseUrl}notification-preferences/`, data);
    }


  // Events
  getAllEvents(page: number, pageSize: number) {
    return this.http.get(`${this.baseUrl}messaging/audit-logs/?page=${page}&page_size=${pageSize}`)
  }

  // Service health status
  healthStatus() {
    return this.http.get(`${this.baseUrl}health-status/`)

  }

  // Dashboard:
  dashboard(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}dashboard/stats/?page=${page}&page_size=${pageSize}`, data)
  }
  getSuperuserDashboard() {
    return this.http.get(`${this.baseUrl}dashboard/superuser/`);
  }
  vehicleMovement(data: object) {
    return this.http.post(`${this.baseUrl}dashboard/vehicle-movement/`, data)
  }
  exportTodayActivity(data: Object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}dashboard/stats/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }

  // Notifications:

  notifications() {
    return this.http.get(`${this.baseUrl}notifications`)
  }

  // Cameras:
  addcamera(data: Object) {
    return this.http.post(`${this.baseUrl}cameras/`, data)
  }
  getWebhookProviders(page: number, pageSize: number, searchText: string = '') {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText.trim()) {
      params = params.set('search', searchText.trim());
    }
    return this.http.get(`${this.baseUrl}webhook-providers/`, { params });
  }
  getWebhookProvider(id: number) {
    return this.http.get(`${this.baseUrl}webhook-providers/${id}/`);
  }
  createWebhookProvider(data: object) {
    return this.http.post(`${this.baseUrl}webhook-providers/`, data);
  }
  updateWebhookProvider(id: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}webhook-providers/${id}/`, data);
  }
  listSalesInstallationPartners(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.business_type) {
      params = params.set('business_type', filters.business_type);
    }
    if (filters.city) {
      params = params.set('city', filters.city);
    }
    if (filters.state) {
      params = params.set('state', filters.state);
    }
    if (filters.active_only) {
      params = params.set('active_only', filters.active_only);
    }
    return this.http.get(`${this.baseUrl}sales-installation-partners/`, { params });
  }
  getSalesInstallationPartner(id: number) {
    return this.http.get(`${this.baseUrl}sales-installation-partners/${id}/`);
  }
  createSalesInstallationPartner(data: object) {
    return this.http.post(`${this.baseUrl}sales-installation-partners/`, data);
  }
  updateSalesInstallationPartner(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}sales-installation-partners/${id}/`, data);
  }
  deleteSalesInstallationPartner(id: number) {
    return this.http.delete(`${this.baseUrl}sales-installation-partners/${id}/`);
  }
  createSalesInstallationPartnerFromLead(leadId: number) {
    return this.http.post(`${this.baseUrl}sales-installation-partners/from-lead/`, { lead_id: leadId });
  }
  getWebhookApiKeys(
    page: number,
    pageSize: number,
    searchText: string = '',
    providerId: number | string | null = null,
    organizationId: number | string | null = null
  ) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText.trim()) {
      params = params.set('search', searchText.trim());
    }
    if (providerId) {
      params = params.set('provider', providerId.toString());
    }
    if (organizationId) {
      params = params.set('organization', organizationId.toString());
    }
    return this.http.get(`${this.baseUrl}webhook-api-keys/`, { params });
  }
  createWebhookApiKey(data: object) {
    return this.http.post(`${this.baseUrl}webhook-api-keys/`, data);
  }
  updateWebhookApiKey(id: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}webhook-api-keys/${id}/`, data);
  }
  viewCameras(page: number, pageSize: number, searchText: string | null, orgId: number | string = '') {
    return this.http.get(`${this.baseUrl}cameras/?page=${page}&page_size=${pageSize}&search=${searchText}&org_id=${orgId}`)
  }
  deleteCamera(id: number, orgId: number) {
    return this.http.delete(`${this.baseUrl}cameras/${id}/?org_id=${orgId}`)
  }
  getCamera(pk: number, orgId: number) {
    return this.http.get(`${this.baseUrl}cameras/${pk}/?org_id=${orgId}`)

  }
  updateCamera(pk: number, orgId: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}cameras/${pk}/?org_id=${orgId}`, data)

  }
  exportCamera(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}cameras/export_to_excel`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getBridgeTypes() {
    return this.http.get<Array<{ value: string; label: string; max_lpr_supported: number; price: number }>>(
        `${this.baseUrl}bridge-types/`
    );
  }

  viewBridges(page: number, pageSize: number, searchText: string | null, orgId: number | string) {
    return this.http.get(
        `${this.baseUrl}bridges/?page=${page}&page_size=${pageSize}&search=${searchText || ''}&org_id=${orgId}`
    );
  }

  addBridge(data: object) {
    return this.http.post(`${this.baseUrl}bridges/`, data);
  }

  getBridge(pk: string, orgId: number | string) {
    return this.http.get(`${this.baseUrl}bridges/${pk}/?org_id=${orgId}`);
  }

  updateBridge(pk: string, orgId: number | string, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}bridges/${pk}/?org_id=${orgId}`, data);
  }

  exportBridges(
      pageNo: number,
      pageSize: number,
      searchText: string | null,
      orgId: number | string
  ): Observable<HttpResponse<Blob>> {
    return this.http.get(
        `${this.baseUrl}bridges/export_to_excel/?org_id=${orgId}&page=${pageNo}&page_size=${pageSize}&search=${searchText || ''}`,
        {
          responseType: 'blob',
        observe: 'response'
      }
    );
  }

    getBridgeCredentials(bridgeId: string, orgId: number | string) {
        return this.http.get<Array<{
            id: number;
            masked_key: string;
            is_active: boolean;
            last_used_at: string | null;
            created_at: string;
        }>>(`${this.baseUrl}bridges/${bridgeId}/credentials/?org_id=${orgId}`);
    }

    createBridgeCredential(bridgeId: string, orgId: number | string) {
        return this.http.post<{
            id: number;
            raw_key: string;
            masked_key: string;
            is_active: boolean;
            created_at: string;
        }>(`${this.baseUrl}bridges/${bridgeId}/credentials/?org_id=${orgId}`, {});
    }

    revokeBridgeCredential(bridgeId: string, credentialId: number, orgId: number | string) {
        return this.http.patch(
            `${this.baseUrl}bridges/${bridgeId}/credentials/${credentialId}/?org_id=${orgId}`,
            {is_active: false}
        );
    }

  // HotList:
  addHotList(data: Object) {
    return this.http.post(`${this.baseUrl}hotlisted-vehicles/`, data)
  }
  getHotList(page: number, pageSize: number, searchText: string | null) {
    return this.http.get(`${this.baseUrl}hotlisted-vehicles/?page=${page}&page_size=${pageSize}&search=${searchText}`)
  }
  removeHotlist(id: number) {
    return this.http.delete(`${this.baseUrl}hotlisted-vehicles/${id}/`)
  }
  exportHotlisted(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}hotlisted-vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
  // Analytics
  analytics(data: Object) {
    return this.http.post(`${this.baseUrl}vehicle-area-distribution/?group_by=location`, data)
  }

  getStaleUnmatchedVehicles(data: object, page: number, pageSize: number) {
    return this.http.post(
      `${this.baseUrl}stale-unmatched-vehicles/?page=${page}&page_size=${pageSize}`,
      data
    );
  }
  // Alerts
  alert(page: number, 
    pageSize: number, 
    searchText: string | null, 
    alertType: string | null,
        dateFilter: string | null,
        monitoringTypes: string[] = [],
  ): Observable<any> {
      let params = new HttpParams()
          .set('page', page)
          .set('page_size', pageSize)
          .set('search', searchText || '')
          .set('alert_type', alertType || '')
          .set('date_filter', dateFilter || '');
      monitoringTypes.forEach(monitoringType => {
          params = params.append('monitoring_type', monitoringType);
      });
      return this.http.get(`${this.baseUrl}vehicle-alerts`, {params});
  }

    exportAlerts(
        searchText: string | null,
        alertType: string | null,
        dateFilter: string | null,
        monitoringTypes: string[] = [],
    ): Observable<HttpResponse<Blob>> {
        let params = new HttpParams();
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertType) {
            params = params.set('alert_type', alertType);
        }
        if (dateFilter) {
            params = params.set('date_filter', dateFilter);
        }
        monitoringTypes.forEach(monitoringType => {
            params = params.append('monitoring_type', monitoringType);
        });
        return this.http.get(`${this.baseUrl}vehicle-alerts/export_to_excel/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
    }

    // Vehicle Monitoring (management)
    getGroupedVehicleMonitoring(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertTypes: string[],
        severities: string[] = [],
    ): Observable<any> {
        let params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertTypes?.length) {
            alertTypes.forEach(alertType => {
                params = params.append('alert_type', alertType);
            });
        }
        if (severities?.length) {
            severities.forEach(severity => {
                params = params.append('severity', severity);
            });
        }
        return this.http.get(`${this.baseUrl}vehicle-monitoring/`, {params});
    }

    getVehicleMonitoringDetail(id: number): Observable<any> {
        return this.http.get(`${this.baseUrl}vehicle-monitoring/${id}/`);
    }

    deleteVehicleMonitoringRules(ruleIds: number[]): Observable<any> {
        return this.http.post(`${this.baseUrl}vehicle-monitoring/delete/`, {rule_ids: ruleIds});
    }

    bulkUploadVehicleMonitoring(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-vehicle-monitoring/`, data);
    }

    /** @deprecated Use bulkUploadVehicleMonitoring */
    bulkUploadVehicleAlertRules(data: Object) {
        return this.bulkUploadVehicleMonitoring(data);
    }

    addVehicleMonitoringRule(data: object) {
        return this.http.post(`${this.baseUrl}vehicle-alert-rules/`, data);
    }

    /** @deprecated Use addVehicleMonitoringRule */
    addVehicleAlertRule(data: object) {
        return this.addVehicleMonitoringRule(data);
    }

    getVehicleMonitoringRule(id: number) {
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/${id}/`);
    }

    /** @deprecated Use getVehicleMonitoringRule */
    getVehicleAlertRule(id: number) {
        return this.getVehicleMonitoringRule(id);
    }

    updateVehicleMonitoringRule(id: number, data: object) {
        return this.http.patch(`${this.baseUrl}vehicle-alert-rules/${id}/`, data);
    }

    /** @deprecated Use updateVehicleMonitoringRule */
    updateVehicleAlertRule(id: number, data: object) {
        return this.updateVehicleMonitoringRule(id, data);
    }

    deleteVehicleMonitoringRule(id: number) {
        return this.http.delete(`${this.baseUrl}vehicle-alert-rules/${id}/`);
    }

    /** @deprecated Use deleteVehicleMonitoringRule */
    deleteVehicleAlertRule(id: number) {
        return this.deleteVehicleMonitoringRule(id);
    }

    getVehicleMonitoringRulesByVehicle(vehicleNumber: string): Observable<any> {
        const params = new HttpParams().set('vehicle_number', vehicleNumber).set('page_size', 100);
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/`, {params});
    }

    /** @deprecated Use getVehicleMonitoringRulesByVehicle */
    getVehicleAlertRulesByVehicle(vehicleNumber: string): Observable<any> {
        return this.getVehicleMonitoringRulesByVehicle(vehicleNumber);
    }

    getVehicleMonitoringRules(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertType: string | null,
    ): Observable<any> {
        let params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertType) {
            params = params.set('alert_type', alertType);
        }
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/`, {params});
    }

    /** @deprecated Use getVehicleMonitoringRules */
    getVehicleAlertRules(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertType: string | null,
    ): Observable<any> {
        return this.getVehicleMonitoringRules(page, pageSize, searchText, alertType);
    }

    exportVehicleMonitoringRules(
        searchText: string | null,
        alertTypes: string[] | string | null,
        severities: string[] | string | null = [],
    ): Observable<HttpResponse<Blob>> {
        let params = new HttpParams();
        if (searchText) {
            params = params.set('search', searchText);
        }
        const normalizedTypes = Array.isArray(alertTypes)
            ? alertTypes
            : alertTypes
                ? [alertTypes]
                : [];
        normalizedTypes.forEach(alertType => {
            params = params.append('alert_type', alertType);
        });
        const normalizedSeverities = Array.isArray(severities)
            ? severities
            : severities
                ? [severities]
                : [];
        normalizedSeverities.forEach(severity => {
            params = params.append('severity', severity);
        });
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/export_to_excel/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
    }

    /** @deprecated Use exportVehicleMonitoringRules */
    exportVehicleAlertRules(
        searchText: string | null,
        alertTypes: string[] | string | null,
    ): Observable<HttpResponse<Blob>> {
        return this.exportVehicleMonitoringRules(searchText, alertTypes);
    }

}
